module.exports = __webpack_public_path__ + "img/rogue_arena.54670abf.png";